import React, { useEffect, useState } from "react";
import PopupModal from "../../Components/ModalComponent/PopupModal";
import InputComponent from "../../Components/InputComponent/InputComponent";
import AlertBox from "../../Components/AlertBox/AlertBox";
import MenuHeader from "../../Components/MenuHeaderSection/MenuHeader";
import DataTable from "../../Components/DataTable/DataTable";
import { Input, Popconfirm, Skeleton } from "@arco-design/web-react";
import { ManageApis } from "../../AppServices/ManageApi";
import { convertUtcToBrowserTimeZone, dataTableInitialLoader, formatingValue, limitCharacters } from "../../Functions/Utils";
// import InputComponent2 from "../../Components/InputComponent copy/InputComponent2";
import InputComponent2 from "../../Components/InputComponent/InputComponent2";
import Loader from "../../Components/LoaderComponent/Loader";
import moment from "moment";
// import moment from "moment-timezone";
const InputSearch = Input.Search;

function Services() {
    const AlertinitialValue = {
        show: false,
        message: "",
        isfalse: false,
        isSuccess: false,
    };
    const [serviceDataList, setServiceDataList] = useState([]);
    const [data, setData] = useState([]);
    const [loader, setloader] = useState(false);
    const [tableLoader, setTableLoader] = useState(false);
    const [ServiceData, setServiceData] = useState({name:"",logTablePrefix:""});
    const [currentPage, setcurrentPage] = useState(1);
    const [visible, setvisible] = useState({ show: false, type: "" });
    const [showAlert, setShowAlert] = useState(AlertinitialValue);
    const [pageSize, setpageSize] = useState(10);
    const [searchText, setSearchText] = useState('')

    const handleEditClientName = (param) => {
        setServiceData((pre) => ({}));
        setvisible((pre) => ({ show: true, type: "Edit_Service" }));
        //console.log(param);

        setServiceData({name:param?.name,logTablePrefix:param?.logTablePrefix,id:param.id});
    };
    useEffect(() => {
        //console.log(ServiceData);
    }, [ServiceData]);

    const handleSubmit = async () => {
        
        try {
            setloader(true);
            setvisible((pre) => ({ show: false, type: "" }));
            let response;
            const { createdDate, id, name,logTablePrefix } = ServiceData;
            //console.log(id);
          
            switch (visible?.type) {
                case "Edit_Service":
                    response = await ManageApis("post", global.updateServiceDetails, {
                        id: id,
                        name: name.trim(),
                        logTablePrefix:logTablePrefix.trim()

                    });
                    if (response.message === "Success") {
                        setShowAlert((pre) => ({
                            ...pre,
                            show: true,
                            message: response?.response_data?.message,
                            isSuccess: true,
                            isfalse: false,
                        }));
                        setloader(false);
                        setServiceData((pre) => ({}));
                        setData(response?.response_data);
                        setServiceDataList((pre) => response?.response_data);
                        getServiceListDetails();
                        setServiceData((pre) => ({}));
                    } else {
                        setServiceData((pre) => ({}));
                        setloader(false);

                        setShowAlert((pre) => ({
                            ...pre,
                            show: true,
                            message: response?.response_data?.message,
                            isfalse: true,
                        }));
                    }

                    break;
                case "New_Service":
                    response = await ManageApis("post", global.addServiceDetails, {
                        name: name.trim(),
                        logTablePrefix:logTablePrefix
                    });
                    if (response.message === "Success") {
                        setvisible((pre) => ({ show: false, type: "" }));
                        setServiceData((pre) => ({}));
                        setShowAlert((pre) => ({
                            ...pre,
                            show: true,
                            message: response?.response_data?.message,
                            isSuccess: true,
                        }));
                        setloader(false);
                        setServiceData((pre) => ({}));
                        getServiceListDetails();
                    } else {
                        setServiceData((pre) => ({}));
                        setShowAlert((pre) => ({
                            ...pre,
                            show: true,
                            message: response?.response_data?.message,
                            isfalse: true,
                        }));
                        setloader(false);
                    }
                    break;

                default:
                    break;
            }
        } catch (error) {
            setloader(false);
            setvisible((pre) => ({ show: false, type: "" }));
            setServiceData((pre) => ({}));
            //console.log(error);
        }
    };
    // function for delete service
    const handleDeleteService = async (param) => {
        try {
            setloader(true);
            const data = {
                id: param,
            };
            let result = await ManageApis("post", global.deleteServiceDetails, data);
            if (result.message == "Success") {
                setShowAlert((pre) => ({
                    ...pre,
                    show: true,
                    message: result?.response_data?.message,
                    isSuccess: true,
                }));
                getServiceListDetails();
                setloader(false);
            } else {
                //console.log(result)
                setShowAlert((pre) => ({
                    ...pre,
                    show: true,
                    message: result?.response_data?.message ? result?.response_data?.message : "Something Went Wrong",
                    isfalse: true,
                }));
                setloader(false);
            }
        } catch (error) {
            setloader(false);
            //console.log(error);
        }
    };


    const TableColumn = [
        {
            title: "Service Name",
            dataIndex: "name",
            // sorter: (a, b) => {                            //not use currently if need sort uncomment it
            //   if (a.name > b.name) {
            //     return 1;
            //   }
            //   if (a.name < b.name) {
            //     return -1;
            //   }
            //   return 0;
            // },
            headerCellStyle: {
                backgroundColor: "var(--mastercolor2)",
                color: "#fff",
            },
        },
        {
            title: "Modified Date",
            dataIndex: "modifiedDate",
            headerCellStyle: {
                backgroundColor: "var(--mastercolor2)",
                color: "#fff",
            },
            render: (v, record) => {
                // ""
                return (<div>{convertUtcToBrowserTimeZone(record.modifiedDate)}</div>)
            }
        },
        {
            title: "Service Id",
            dataIndex: "id",
            headerCellStyle: {
                backgroundColor: "var(--mastercolor2)",
                color: "#fff",
            },
        },
        {
            title: "Action",
            dataIndex: "action",
            render: (v, record) => {
                //console.log({ record });
                return tableLoader ? (
                    <Skeleton text={{ rows: 1, width: 100 }} />
                ) : (
                    <div className="col-12 ">
                        <div className="d-flex flex-column flex-md-row  justify-content-center mt-3 mt-md-0  gap-2">
                            <button
                                className="btn px_btn btn-master-line py-1 rounded fw_500 font_12 w-100"
                                onClick={() => handleEditClientName(record)}
                            >
                                Edit
                            </button>

                            <Popconfirm
                                title="Are you Sure ?"
                                okText={"OK"}
                                cancelText={"Cancel"}
                                onOk={() => handleDeleteService(record.id)}
                            >
                                <button className="btn px_btn btn-master py-1 rounded fw_500 font_12 w-100">
                                    Delete
                                </button>
                                {/* <DeleteTwoTone /> */}
                            </Popconfirm>
                        </div>
                    </div>
                );
            },
            headerCellStyle: {
                backgroundColor: "var(--mastercolor2)",
                color: "#fff",
            },
            width: "300px",
        },
    ];
    useEffect(() => {
        console.log(ServiceData)
    }, [ServiceData]);

    useEffect(() => {
        getServiceListDetails();
    }, []);

    // function for get service Data
    const getServiceListDetails = async () => {
        // ""
        try {
            setloader(true);
            setServiceDataList(dataTableInitialLoader(TableColumn));
            let response = await ManageApis("get", global.getServicesByUser);
            //console.log(response);

            if (response.message === "Success") {
                setloader(false);
                setData(response?.response_data);
                setServiceDataList((pre) => response?.response_data);
            } else {
                setloader(false);
                //console.log(response);
                setShowAlert((pre) => ({
                    ...pre,
                    show: true,
                    message: response?.response_data?.message,
                    isfalse: true,
                }));
            }
        } catch (error) {
            setloader(false);
            //console.log(error);
        }
    };
    // onchange function for pagination
    function onChangeTable(pagination) {
        // ""
        //console.log(pagination);
        const { current, pageSize } = pagination;
        setTableLoader(true);
        setServiceDataList(dataTableInitialLoader(TableColumn));
        setTimeout(() => {
            setServiceDataList(
                data.slice((current - 1) * pageSize, current * pageSize)
            );

            setcurrentPage(current);
            setpageSize(pageSize);
            setTableLoader(false);
        }, 2000);
    }

    useEffect(() => {
        // ""
        //console.log(serviceDataList)
    }, [serviceDataList])

    const handleChange = (event) => {
        const { name, value } = event.target;
        if (visible?.type == "Edit_Service") {
            setServiceData((pre) => ({ ...pre, [name]: value.trimStart() }));
        } else {
            setServiceData((pre) => ({ ...pre,[name]: value.trimStart() }));
        }
    };

    const handlesearch = (value) => {
        setSearchText(limitCharacters(value, 20))
        try {
            if (limitCharacters(value, 20)) {
                setServiceDataList(() => (
                    data.filter((itm) => (itm?.name?.toLowerCase().includes(value?.toLowerCase())))
                ))
            } else {
                setServiceDataList(data)
            }
        } catch (error) {
        }
    }


useEffect(() => {
  console.log(ServiceData)
}, [ServiceData])

    return (
        <>
            {loader && <Loader />}
            <AlertBox
                show={showAlert.show}
                message={showAlert.message}
                enableFailIcon={showAlert.isfalse}
                enableSuccessIcon={showAlert.isSuccess}
                handlecancel={() => setShowAlert(AlertinitialValue)}
            />
            <div className="px-3">
                {/* <MenuHeader
                    btnLabel={"Add Service"}
                    handleChange={() =>
                        setvisible((pre) => ({
                            ...pre,
                            show: true,
                            type: "New_Service",
                        }))
                    }
                    headerName={false}
                    handlesearchTextChange={handlesearchTextChange}

                    
                /> */}
                <div className="d-flex justify-content-end mb-2 gap-2">
                    <div className="arco_inputsearch">
                        <InputSearch value={searchText} onChange={handlesearch} allowClear placeholder='Enter service name ' />
                    </div>
                    <div>
                        <button
                            className="btn btn-master flex-fill flex-md-grow-0 font_14 px-4"
                            onClick={() =>
                            setvisible((pre) => ({
                            ...pre,
                            show: true,
                            type: "New_Service",
                            }))
                        }
                        >
                            Add Service
                        </button>
                    </div>
                </div>

                {/* data table component for list data */}
                <div className="overflow-auto accountServicesDashBoard scrollbar1">
                    <DataTable
                        columnData={TableColumn}
                        rowData={serviceDataList}
                        loading={tableLoader}
                        pageSize={pageSize}
                        current={currentPage}
                        total={serviceDataList.length}
                        onChangeTable={onChangeTable}
                    />
                </div>

                {/* <DataTable
                    columnData={TableColumn}
                    rowData={serviceDataList}
                    loading={tableLoader}
                    pageSize={pageSize}
                    current={currentPage}
                    total={data.length}
                    onChangeTable={onChangeTable}
                /> */}
            </div>

            <PopupModal
                title={visible?.type?.replaceAll("_", " ")}
                size="md"
                visible={visible.show}
                handleClose={() => {
                    setServiceData({name:"",logTablePrefix:""});
                    setvisible((pre) => ({ show: false, type: "" }));
                }}
            >
                <div className="d-grid gap-2">
                    <InputComponent2
                        label={"Service Name"}
                        name={"name"}
                        onchange={handleChange}
                        value={ServiceData?.name}
                        maxLength={50}
                    />
                     <InputComponent2
                        label={"Log Table Prefix"}
                        name={"logTablePrefix"}
                        onchange={handleChange}
                        value={ServiceData?.logTablePrefix}
                        maxLength={50}
                    />
                    <div className="pt-1">
                        <button
                            className="btn px_btn btn-master px-4 rounded fw_500 font_12 w-100"
                            disabled={
                                Object.values(ServiceData).some(itm=>!itm) || !Object.values(ServiceData).length
                            }
                            onClick={handleSubmit}
                        >
                            Submit
                        </button>
                    </div>
                </div>
            </PopupModal>
        </>
    );
}

export default Services;
